import { Joi } from 'app-webtech-core/schemas';
import { selectors, actions } from 'app-webtech-core';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { VOD_EPISODE_WATCH } from './types';
import { getChannelByTimelineId } from '../../playbackSession/containers/helpers/getChannelByTimelineId';

const vodEpisodeWatchActionPayloadSchema = Joi.object().keys({
  id: Joi.string().required(),
});

export const vodEpisodeWatchAction = actionCreator(
  VOD_EPISODE_WATCH,
  vodEpisodeWatchActionPayloadSchema,
);

export const vodEpisodeWatchThunkAction = (id) => (dispatch, getState) => {
  const state = getState();
  const payload = { id };
  dispatch(vodEpisodeWatchAction(payload));
  dispatch(actions.podTrackerAds.setAdsPlaying({ isAdsPlaying: false }));
  const { clips } = selectors.playbackSession.properties(state);
  if (clips && clips.length > 0) {
    const { episodeID, clipID, timelineID } = clips[0];
    dispatch(
      actions.player.clipEnds({
        episodeID,
        clipID,
        channelID: getChannelByTimelineId(timelineID, state),
        programTimelineID: timelineID,
      }),
    );
    dispatch(
      actions.player.episodeEnds({
        episodeID,
        clipID,
        channelID: getChannelByTimelineId(timelineID, state),
        programTimelineID: timelineID,
      }),
    );
    if (selectors.guide.properties(state).isAutoPlay) {
      dispatch(actions.guide.setAutoPlay({ isAutoPlay: false }));
    }
  }
  if (state.viral.isEnabled) {
    dispatch(actions.player.clipEnds());
    if (selectors.guide.properties(state).isAutoPlay) {
      dispatch(actions.guide.setAutoPlay({ isAutoPlay: false }));
    }
  }
};
